import { Component, OnInit, ElementRef,ChangeDetectionStrategy } from '@angular/core';
import { OnDemandPreloadService } from 'src/app/shared/services/preloadOnDemandService';
import { LoggerService } from 'src/app/shared/services/logger/logger.service';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullLayoutComponent implements OnInit {

  constructor(private service : OnDemandPreloadService, private loggerService:LoggerService,
   ) { }

  ngOnInit() {
    // console.log("full layout,ngOnInitchecked")
  }
  ngOnChanges() {
    // console.log("full layout,ngOnChanges - data is ${this['data']}");
}
ngAfterViewInit() {
  // console.log("full layout,ngAfterViewInit");

  //------------importing kendo and material design modules---------------------//
  this.service.startPreload("kendo");
  this.service.startPreload("material-design");
}

ngAfterContentInit() {
  // console.log("full layout,ngAfterContentInit");

  }
  ngAfterContentChecked() {
  // console.log("full layout,ngAfterContentChecked");
  }
  ngAfterViewChecked() {
  // console.log("full layout,ngAfterViewChecked");
  }
 
}